import { render } from "./SSOSettingsForm.vue?vue&type=template&id=160a9090&ts=true"
import script from "./SSOSettingsForm.vue?vue&type=script&lang=ts"
export * from "./SSOSettingsForm.vue?vue&type=script&lang=ts"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css"
import "./SSOSettingsForm.vue?vue&type=style&index=1&id=160a9090&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__